// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"736":"chartjs","744":"actioncable"}[chunkId] || chunkId) + "-" + {"19":"16e0e532080c33600269","736":"aa9ab3a3ff03cc3c0b34","744":"a2d0c7e22f103d61f631"}[chunkId] + ".chunk.js";
};